import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsSelectAttendandScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.SelectAttendant />
    </View>
  );
};

export default PreProposalsSelectAttendandScreen;
